<section
	id="calendar-sidebar"
	class="sec-container sec-aux-content"
	[@enterAnimation]
>
	<h2 class="sidebar-widget--title">
		{{ 'GENERAL.SCHEDULINGS' | translate }}
	</h2>



	<!-- Last * appointments with no reason -->
	<div
		*ngIf="
			!isLoading &&
			showLastEvents &&
			eventsForWeekWithoutPromptuary &&
			eventsForWeekWithoutPromptuary.length > 0
		"
		class="row today-registers"
	>
	<appointment-preview-item
			class="row remove--last-before"
			[events]="eventsForWeekWithoutPromptuary"
			[isPromptuaryCard]="true"
		>
		</appointment-preview-item>
	</div>

	<!-- No events for selected day. -->
	<div
		*ngIf="!isLoading && eventsForToday && eventsForToday.length == 0"
		class="row user-card shadow noEvents"
	>
		<p *ngIf="isTodayVisible" class="font--weight-700">
			{{ 'SCHEDULE.NOEVENTSFORTODAY' | translate }}
			<fa-icon [icon]="['far', 'frown']"></fa-icon>
		</p>
		<p *ngIf="!isTodayVisible" class="font--weight-700">
			{{ 'SCHEDULE.NOEVENTSFORSELDAY' | translate }} {{ screenDate }}
			<fa-icon [icon]="['far', 'frown']"></fa-icon>
		</p>
		<p class="pLink" (click)="addEvent()">
			{{ 'SCHEDULE.NEWSESSION' | translate }}
		</p>
	</div>

	<!-- Has events for selected day. -->
	<div
		*ngIf="!isLoading && eventsForToday && eventsForToday.length > 0"
		class="row user-card shadow noEvents"
	>
		<p *ngIf="isTodayVisible" class="font--weight-700">
			{{ 'SCHEDULE.TODAYSESSIONS' | translate }}
		</p>
		<p *ngIf="!isTodayVisible" class="font--weight-700">
			{{ 'SCHEDULE.DAYSESSIONS' | translate }} {{ screenDate }}
		</p>
		<p
			*ngIf="!isLoading && !isTodayVisible"
			class="todayEventsLink"
			(click)="backToToday()"
		>
			{{ 'OPERATIONS.SHOWTODAYEVENTS' | translate }}
		</p>
		<p class="pLink" (click)="addEvent()">
			{{ 'SCHEDULE.NEWSESSION' | translate }}
		</p>
	</div>

	<!-- List today events. -->
	<div
		*ngIf="!isLoading && eventsForToday && eventsForToday.length > 0"
		class="row today-registers"
	>
		<appointment-preview-item
			class="row today-registers"
			*ngIf="!isLoading && eventsForToday && eventsForToday.length > 0"
			[events]="eventsForToday"
			(showEventDetails)="showEventDetails($event)"
		>
		</appointment-preview-item>
	</div>
</section>
